import { ClientsState } from "./clients.state";
import { ActionTypes } from "./clients.actions";

export const ClientsReducer = (
    state: ClientsState = new ClientsState(),
    action: any,
  ): ClientsState => {

    switch (action.type) {

        case ActionTypes.GetClients: {
            return {
                ...state,
                loading: true
            };
        }

        case ActionTypes.GetClientsSucceed: {
            return {
                ...state,
                record: action.clients,
                loading: false,
                error: null
            };
        }

        case ActionTypes.GetClientsFail: {
            return {
                ...state,
                loading: false,
                error: action.error,
                record: []
            };
        }

        default: {
            return state;
        }
    }

};
